import { render } from "./DemandDeleteModal.vue?vue&type=template&id=3526a6ce&scoped=true"
import script from "./DemandDeleteModal.vue?vue&type=script&lang=js"
export * from "./DemandDeleteModal.vue?vue&type=script&lang=js"

import "./DemandDeleteModal.vue?vue&type=style&index=0&id=3526a6ce&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3526a6ce"]])

export default __exports__